// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Oxygen', 'Oxygen Fallback'","fontStyle":"normal"},"className":"__className_3c624e","variable":"__variable_3c624e"};